import { motion, AnimatePresence } from "framer-motion";

// Shared, restrained motion primitives for card/grid entrance animation.
// Kept lightweight (no springs on lists) so scrolling large grids stays fast.
export const fadeUp = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] } },
};

export const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06, delayChildren: 0.02 } },
};

export const StaggerGrid = ({ children, className = "", ...rest }) => (
  <motion.div variants={staggerContainer} initial="hidden" animate="show" className={className} {...rest}>
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", ...rest }) => (
  <motion.div variants={fadeUp} className={className} {...rest}>
    {children}
  </motion.div>
);

export { motion, AnimatePresence };
